import {
  ElementRef,
  HostListener,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Selection } from 'd3-selection';
import { D3Event } from './charts.model';

interface Margin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export abstract class ChartComponent {
  svg: Selection<any, {}, null, undefined>;
  width: number;
  height: number;
  chartElement: HTMLElement;

  private _margin = { top: 20, right: 20, bottom: 30, left: 50 };

  @Input()
  set margin(value: Margin) {
    this._margin = { ...this._margin, ...value };
  }
  get margin() {
    return this._margin;
  }

  @Output() clickElement = new EventEmitter<D3Event>();
  @Output() mouseOverElement = new EventEmitter<D3Event>();
  @Output() mouseOutElement = new EventEmitter<D3Event>();

  @HostListener('window:resize', ['$event'])
  onResize(ev: UIEvent) {
    this.redrawChart();
  }
  @HostBinding('style.height') get setHeight() {
    return '100%';
  }
  @HostBinding('style.width') get setWidth() {
    return '100%';
  }
  @HostBinding('style.display') get setDisplay() {
    return 'block';
  }

  protected constructor(protected el: ElementRef) {}

  updateChartDimentions() {
    this.chartElement = this.el.nativeElement;
    this.width = this.chartElement.offsetWidth;
    this.height = this.chartElement.offsetHeight;
  }

  redrawChart() {
    this.updateChartDimentions();
    this.removeChart();
    this.drawChart();
  }

  public removeChart() {
    const children: HTMLElement[] = this.el.nativeElement.childNodes;
    for (const child of children) {
      child.remove();
    }
  }

  abstract drawChart(): void;
}
